import type { ReactNode } from 'react';

import { Label, LabelValueList, Value } from './label-value.styles';

interface Props {
  label: string;
  value: string | ReactNode;
  isHightlight?: boolean;
  isWithDesktopStyles?: boolean;
}

export const LabelValue = ({
  label,
  value,
  isHightlight,
  isWithDesktopStyles,
}: Props) => (
  <LabelValueList $isWithDesktopStyles={isWithDesktopStyles}>
    <Label>{label}</Label>
    <Value $isHightlight={isHightlight}>{value}</Value>
  </LabelValueList>
);
